<template>
  <b-container>
    <b-form-group
      :label="$t('system.module.sequenceNumber')"
      label-for="sequenceNumber"
    >
      <base-input-integer
        id="sequencNumber"
        :placeholder="$t('system.module.sequenceNumber')"
        :value.sync="model.sequenceNumber"
      >
      </base-input-integer>
    </b-form-group>
    <b-form-group
      label-for="DisplayName"
      :label="$t('system.module.moduleName')"
    >
      <b-form-input
        id="ModuleName"
        type="text"
        placeholder="Informe o nome do módulo"
        v-model="model.name"
      />
      <span class="text-danger" v-if="modelstate['Name']">
        {{ modelstate["Name"][0] }}
      </span>
    </b-form-group>
    <b-form-group
      label-for="ModuleType"
      label="Tipo do módulo"
    >
        <b-form-select
          v-model="model.type"
          id="moduleType"
          :options="moduleOptions"
        ></b-form-select>
      <span class="text-danger" v-if="modelstate['Type']">
        {{ modelstate["Type"][0] }}
      </span>
    </b-form-group>
    <b-row class="text-center">
      <b-col md="12" v-if="model.inputImage != null && model.inputImage != ''">
        <base-attachment-item
          :attachment="model.inputImage"
          :discard-visible="true"
          @discard="fileRemove"
        >
        </base-attachment-item>
      </b-col>
      
    </b-row>
    <div>
      <b-form-file
        placeholder="Selecione uma imagem"
        :lang="$i18n.locale"
        v-on:change="handleFileUpload($event)"
        :no-drop="true"
      ></b-form-file>
    </div>
    <!-- {{model}} -->
  </b-container>
</template>
<script>
export default {
  name: "ModuleCrudData",
  components: {
    BaseInputInteger: () =>
      import("@/components_rms/base/BaseInputInteger.vue"),
    BaseAttachmentItem: () =>
      import("@/components_rms/base/BaseAttachmentItem.vue"),
  },
  props: {
    model: Object,
    modelstate: Object,
  },
  data() {
    return {
      image: "",
      moduleOptions:[
        {value: 1, text: "Módulo customizado"},
        {value: 2, text: "BI"},
        {value: 3, text:"Checklist"},
        {value: 4, text: "Torre de Controle"},
        {value: 5, text: "Workflow"},
        
      ]
    };
  },
  methods: {
    updateImageSrc(originObject, newValue) {
      this.model.inputImage = newValue;
      this.$forceUpdate();
    },
    fileRemove() {
      this.model.inputImage = null;
      this.$forceUpdate();
    },
    handleFileUpload(e) {
      let file = e.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        this.model.inputImage = reader.result;
        this.$forceUpdate();
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    },
  },
};
</script>
<style scoped>
</style>